import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, Clock3, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const location = useLocation();
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get("session_id");
    if (!sessionId) {
      setState("pending");
      return;
    }
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {}
      attempts.current += 1;
      if (attempts.current < 10) {
        timer = setTimeout(poll, 2000);
      } else {
        setState("pending");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [location.search]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#080C14] px-6" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-3xl border border-cyan-500/20 bg-[#0E1524]/80 p-10 text-center backdrop-blur-xl">
        {state === "checking" && (
          <>
            <Loader2 size={36} className="mx-auto animate-spin text-cyan-400" />
            <h1 className="font-display mt-5 text-2xl font-extrabold text-slate-50">Vérification du paiement…</h1>
            <p className="mt-3 text-sm text-slate-400">Nous confirmons votre règlement auprès de Stripe.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={40} className="mx-auto text-emerald-400" data-testid="payment-success-icon" />
            <h1 className="font-display mt-5 text-2xl font-extrabold text-slate-50" data-testid="payment-success-title">
              Paiement bien reçu !
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              Merci ! Votre règlement est confirmé. Si votre date n'est pas encore définitivement
              réservée, nous finalisons ensemble le devis et le contrat.
            </p>
          </>
        )}
        {state === "pending" && (
          <>
            <Clock3 size={36} className="mx-auto text-amber-400" data-testid="payment-pending-icon" />
            <h1 className="font-display mt-5 text-2xl font-extrabold text-slate-50">Confirmation en cours</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              Votre paiement est en cours de traitement. Si vous avez bien été débité, la
              confirmation arrivera sous quelques minutes.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-success-back"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-cyan-400/30 px-6 py-3 text-sm font-semibold text-cyan-300 transition-colors hover:border-cyan-400/60 hover:bg-cyan-400/10"
        >
          <ArrowLeft size={15} /> Retour au site
        </Link>
      </div>
    </div>
  );
}
